var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseX12Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.314,
    height: 11.314,
    viewBox: "0 0 11.314 11.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-399.336 -307.191)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(399.336 317.09) rotate(-45)",
    fill: "#85878b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(409.235 318.504) rotate(-135)",
    fill: "#85878b"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX12Px);
export default __webpack_public_path__ + "static/media/close-x-12px.940791ff.svg";
export { ForwardRef as ReactComponent };